import * as React from 'react';
import OutlinedInput from '@mui/material/OutlinedInput';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import ListItemText from '@mui/material/ListItemText';
import Select from '@mui/material/Select';
import Checkbox from '@mui/material/Checkbox';
import Radio from '@mui/material/Radio';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function MultipleSelectCheckmarks(props) {
  const [state, setState] = props.selectionState;

  const singleChoice = props.singleChoice;
  const defaultOption = props.defaultOption;
  
  const options = singleChoice ? [defaultOption].concat(props.options) : props.options;
  
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;
    if (singleChoice) {
	    setState(
	      value === defaultOption ? "" : value
	    );
	} else {
	    setState(
	      // On autofill we get a stringified value.
	      typeof value === 'string' ? value.split(',') : value
	    );
	}
  };

  return (
    <React.Fragment>
      <FormControl sx={{ m: 1, width: '100%' }}>
        <InputLabel id="demo-multiple-checkbox-label">{props.category}</InputLabel>
        <Select
          labelId="demo-multiple-checkbox-label"
          id="demo-multiple-checkbox"
          multiple={!singleChoice}
          value={state}
          onChange={handleChange}
          input={<OutlinedInput label={props.category} />}
          renderValue={(selected) => singleChoice ? selected : selected.join(', ')}
          MenuProps={MenuProps}
        >
          {options.map((option) => (
            <MenuItem key={option} value={option}>
            	{singleChoice ?
            	<Radio checked={state === option || (state === "" && option === defaultOption)} />
            	: <Checkbox checked={state.indexOf(option) > -1} />
              	}
              	<ListItemText primary={option} />
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
}